import { createContext, ReactNode, useContext, useMemo, useState } from "react"

export type ManageType = "increase-amount" | "increase-lock-duration"

type ManageStakeFlowContextValue = {
  manageType: ManageType | undefined
  setManageType: (manageType: ManageType | undefined) => void
}

const ManageStakeFlowContext = createContext<
  ManageStakeFlowContextValue | undefined
>(undefined)

export const useManageStakeFlowContext = () => {
  const context = useContext(ManageStakeFlowContext)
  if (!context) {
    throw new Error(
      "ManageStakeFlowContext used outside of ManageStakeFlowProvider component",
    )
  }

  return context
}

export default function ManageStakeFlowProvider({
  children,
}: {
  children: ReactNode
}) {
  const [manageType, setManageType] = useState<ManageType>()

  const value = useMemo(
    () => ({
      manageType,
      setManageType,
    }),
    [manageType],
  )

  return (
    <ManageStakeFlowContext.Provider value={value}>
      {children}
    </ManageStakeFlowContext.Provider>
  )
}
